import { wordPluralisation } from '@nocowanie/common-ui/helpers';

export type AmenityTranslations = { singular: string; plural: string; genitivePlural: string };

export const amenityBoxStyles = {
    bg: 'gray.100',
    borderRadius: 'sm',
    h: 6,
    pl: 1.5,
    pr: 2,
    gap: 1,
};

export function getOverflowWord(count: number, translations: AmenityTranslations): string {
    return wordPluralisation(
        count,
        translations.singular,
        translations.plural,
        translations.genitivePlural,
    );
}
